import classNames from 'classnames';

import { SanityImage } from '@components/SanityImage';

import { CertificationsProps } from '@interfaces/common';

import styles from './BadgesWithText.module.css';

export const BadgesWithText: React.VFC<CertificationsProps> = ({
	badges,
	title,
	paragraph,
}) => {
	return (
		<section className={styles.wrapper}>
			<ul className={styles.badges}>
				{badges.map(({ _key, image, text }) => (
					<li className={styles.badge} key={_key}>
						<SanityImage className={styles['badge-image']} image={image} />
						<p className={styles['badge-text']}>{text}</p>
					</li>
				))}
			</ul>
			<div className={classNames(styles.text, 'stack-block')}>
				<h2 className="fluid-font-t4-bold">{title}</h2>
				<p className="fluid-font-t5">{paragraph}</p>
			</div>
		</section>
	);
};
